import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          ticks: { fontColor: "#000", fontSize:9},
        }],
        yAxes: [{
          ticks: {fontColor: "#000", fontSize:9},
        }]
      }
    }
  }),
  mounted () {
    
    this.renderChart(this.chartData, this.options)
  }
}